import userDetailsreducer from "./userDetailsreducer";
import { combineReducers } from "redux";
import productsreducer from "./productsreducer";
import cartreducer from "./cartreducer";

export default combineReducers({
  userDetails: userDetailsreducer,
  products: productsreducer,
  cart: cartreducer,
});
